import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, Dropdown, DropdownItem, DropdownToggle, DropdownMenu } from 'reactstrap';
import { ACCOUNTANT_URL, DOCS_URL, POLICY_URL, USERS_URL, WORKFLOW_URL, RISK_URL, REASEGURO_URL, SINIESTROS_URL, ORSAN_LOGO_URL } from 'CONST';
import { signout } from 'helpers/auth';
import { useSelector } from 'react-redux';
import { POSICION_DEUDOR_READ, INBOX_VIEW_READ, ASEGURADOS_POLIZAS_READ } from "helpers/profilePermission";
import isUserHasProfile from "helpers/profileValidator";
import NotificationBell from './shared/NotificationBell';

import 'styles/navbar.css';

const BaseNavbar = () => {
  const [appsOpen, setAppsOpen] = useState(false);
  const [solicitudesOpen, setSolicitudesOpen] = useState(false);
  const [polizasOpen, setPolizasOpen] = useState(false);

  const handleSignOut = (event) => {
    event.preventDefault();
    signout();
  };

  const toggleApps = () => {
    setAppsOpen(!appsOpen);
  };

  const toggleSolicitudes = () => {
    setSolicitudesOpen(!solicitudesOpen);
  };

  const togglePolizas = () => {
    setPolizasOpen(!polizasOpen);
  };

  const user = useSelector((state) => state.login.user);
  const token = useSelector((state) => state.login.id_token);

  const redirectWithToken = (event) => {
    event.preventDefault();

    const url = event.target.href;

    const options = {
      method: 'GET',
      headers: {
        'X-JWT-TOKEN': token,
      },
      credentials: 'include',
    };

    fetch(url, options)
      .then((response) => {
        if (response.ok) {
          window.location.href = url;
        }
      })
      .catch(() => {});
  }

  const getSelectedClass = (path, exact = false) => {
    const currentPath = window.location.pathname;
    const homePath = "/inbox-riesgos";

    // Maneja un arreglo the "paths"
    if (Array.isArray(path)) {
      if (path.some(p => exact ? currentPath === p : currentPath.startsWith(p)))
        return 'nav-selected';
    }

    if (typeof path === 'string') {
      if (exact ? currentPath === path : currentPath.startsWith(path))
        return 'nav-selected';
    }

    // Maneja el "home path"
    if (currentPath === "/" && (Array.isArray(path) ? path.includes(homePath) : homePath === path))
      return 'nav-selected';

    return '';
  };


  return (
    user && (
      <nav className="navbar-content">
        <div className="nav-logo-container">
          <Link to="/users">
            <img src={ORSAN_LOGO_URL} className="nav-logo" alt="" />
          </Link>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
          <ul className="nav-links-group">
            <Dropdown nav className="nav-link-element" isOpen={appsOpen} toggle={toggleApps}>
              <DropdownToggle nav caret className="navbar-header">
                RIESGO DE CREDITO
              </DropdownToggle>
              <DropdownMenu>
                {user.apps.includes('users') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={USERS_URL}>
                      USUARIOS
                    </a>
                  </DropdownItem>
                )}
                {user.apps.includes('docs') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={DOCS_URL}>
                      DOCUMENTOS
                    </a>
                  </DropdownItem>
                )}
                {user.apps.includes('policies') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={POLICY_URL}>
                      PÓLIZA
                    </a>
                  </DropdownItem>
                )}
                {user.apps.includes('accountant') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={ACCOUNTANT_URL}>
                      RESERVAS
                    </a>
                  </DropdownItem>
                )}
                {user.apps.includes('reaseguro') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={REASEGURO_URL}>
                      REASEGURO
                    </a>
                  </DropdownItem>
                )}
                {user.apps.includes('risk') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={RISK_URL}>
                      RIESGO
                    </a>
                  </DropdownItem>
                )}
                {user.apps.includes('workflow') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={WORKFLOW_URL}>
                      SEGURO DE CRÉDITO
                    </a>
                  </DropdownItem>
                )}
                {user.is_orsan && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={SINIESTROS_URL} onClick={redirectWithToken}>
                      SINIESTROS
                    </a>
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
            {(isUserHasProfile(INBOX_VIEW_READ) || isUserHasProfile(POSICION_DEUDOR_READ)) && (
              <>
                {isUserHasProfile(INBOX_VIEW_READ) && (
                  <li className="nav-link-element nav-item">
                    <Link className={`nav-link nav-pill ${getSelectedClass('/inbox-riesgos')}`} to="/inbox-riesgos">
                      Bandeja de Entrada
                    </Link>
                  </li>
                )}
                {isUserHasProfile(POSICION_DEUDOR_READ) && (
                  <li className="nav-link-element nav-item">
                    <Link className={`nav-link nav-pill ${getSelectedClass('/posicion-deudor')}`} to="/posicion-deudor">
                      Posición del Deudor
                    </Link>
                  </li>
                )}
              </>
            )}
            {/*
            {isUserHasProfile(ASEGURADOS_POLIZAS_READ) && (
              <Dropdown nav className="nav-link-element" isOpen={polizasOpen} toggle={togglePolizas}>
                <DropdownToggle nav caret>
                  Pólizas
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>
                    <Link className="nav-link" to="/polizas/asegurados-polizas">
                      Asegurados Pólizas
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            )}
            */}
          </ul>
          <ul className="nav-links-group">
            <li className="nav-link-element nav-ite">
              <NotificationBell />
            </li>
            <li className="nav-link-element nav-ite dropdown">
              <p className="nav-link">{user.username || ''}</p>
            </li>
            <li className="nav-link-element nav-item dropdown">
              <Button className="btn-outline-orsan-logout mr-3" onClick={handleSignOut}>
                Cerrar Sesión
                <FontAwesomeIcon icon={faSignOutAlt} size="1x" className="ml-2" />
              </Button>
            </li>
          </ul>
        </div>
      </nav>
    )
  );
};

export default BaseNavbar;
